import { cn } from "@/lib/utils";

/** Sidebar rail widths — keep in sync with {@link Sidebar} and the desktop header brand zone. */
export const SIDEBAR_WIDTH_EXPANDED_CLASS = "w-[14rem] min-w-[14rem]";
export const SIDEBAR_WIDTH_COLLAPSED_CLASS = "w-[4.5rem] min-w-[4.5rem]";

/** Shared header + sidebar surface — both use the sidebar token. */
export const APP_CHROME_SURFACE_CLASS = "bg-sidebar text-sidebar-foreground";

/** Primary app chrome row (sidebar logo, desktop top bar). */
export const APP_CHROME_PRIMARY_ROW_CLASS = cn(
  APP_CHROME_SURFACE_CLASS,
  "sticky top-0 z-40 h-14 shrink-0",
);

/** Secondary app chrome row (sidebar collapse footer). Matches primary header height. */
export const APP_CHROME_SECONDARY_ROW_CLASS = "flex h-14 shrink-0 items-center";

/** Sidebar footer row (collapse toggle). */
export const APP_CHROME_SIDEBAR_FOOTER_CLASS = cn(
  APP_CHROME_SECONDARY_ROW_CLASS,
  "border-t border-sidebar-border",
);

/**
 * Top inset for the desktop sidebar nav. Matches page content `lg:pt-8`
 * so the first item lines up with the page heading.
 */
export const SIDEBAR_NAV_TOP_PAD_CLASS = "pt-8";

/**
 * Aligns a content-area chrome row with the primary chrome row on lg+.
 * Offsets {@link PageScrollViewport} horizontal/top padding (`lg:p-8`).
 */
export const APP_CONTENT_CHROME_ROW_OFFSET_CLASS = cn(
  "lg:-mx-8 lg:-mt-8 lg:px-8",
  "lg:group-data-[help-dock=open]/page-pad:mr-0 lg:group-data-[help-dock=open]/page-pad:pr-0",
);

/** Horizontal-only offset; keeps {@link PageScrollViewport} top padding for breathing room. */
export const APP_CONTENT_CHROME_ROW_HORIZONTAL_OFFSET_CLASS = cn(
  "lg:-mx-8 lg:px-8",
  "lg:group-data-[help-dock=open]/page-pad:mr-0 lg:group-data-[help-dock=open]/page-pad:pr-0",
);

/** Secondary context bar for nested pages (e.g. project detail shell). */
export const pageSecondaryChromeHeaderClassName = cn(
  APP_CONTENT_CHROME_ROW_HORIZONTAL_OFFSET_CLASS,
  "lg:-mt-5",
  "grid shrink-0 grid-cols-[1fr_auto_1fr] gap-3 pb-4 lg:h-12 lg:items-center lg:pb-0",
);
